import { render } from "./LiniiDocumente.vue?vue&type=template&id=0e7284eb&scoped=true&ts=true"
import script from "./LiniiDocumente.vue?vue&type=script&lang=ts"
export * from "./LiniiDocumente.vue?vue&type=script&lang=ts"

import "./LiniiDocumente.vue?vue&type=style&index=0&id=0e7284eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7284eb"]])

export default __exports__